import { combineReducers } from 'redux';
import customerErasureMethodReducer from './CustomerErasureMethod/store/customerErasureMethodReducer';

export const reducers = combineReducers({
    customerErasureMethod: customerErasureMethodReducer
});